var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-input" }, [
    _c("div", { ref: "header", staticClass: "booking-header-extension" }, [
      _c(
        "div",
        {
          staticClass: "booking-header-close",
          attrs: { "data-component": "booking-header-close" },
        },
        [
          _c("span", {
            staticClass: "icon-close",
            attrs: {
              "aria-hidden": "true",
              tabindex: "0",
              "aria-label": _vm.tc("booking.close"),
            },
            on: { click: _vm.deactivate },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "booking-header-extension-wrapper container" }, [
        _c("div", { staticClass: "booking-header-extension-left" }, [
          _vm.enhancement.name
            ? _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.enhancement.name) + "\n        "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "enhancements-wrapper",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c(_vm.inputComponent, {
          ref: "input",
          tag: "component",
          attrs: { enhancement: _vm.enhancement, data: _vm.value.data },
          on: {
            "is-valid": function ($event) {
              _vm.isValid = $event
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { ref: "footer", staticClass: "booking-footer" }, [
      _c("div", { staticClass: "booking-footer-wrapper container" }, [
        _c(
          "button",
          {
            class: [{ loading: _vm.cartPending }],
            attrs: { disabled: !_vm.isValid },
            on: { click: _vm.updateValue },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("enhancements.addToStay")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }